module.exports = __webpack_public_path__ + "img/whatsapp-icon.8351ab1b.svg";